import { messageConstants } from "../_constants"
import { APIcallFunction, headerForPrivateAPI } from "../_helpers";
import { alertActions } from "./alert.actions";

const messageSend = (data) => {
    try {
        const credential = {
            method: 'POST',
            header: headerForPrivateAPI(),
            body: data,
            endPoint: "/message/sendMessage"
        }
        return (dispatch) => {
            dispatch(request({ data }));
            APIcallFunction(credential).then((message) => {
                dispatch(success(message));
                dispatch(alertActions.success("success"));
                // dispatch(alertActions.success(user?.message))
            },
                (error) => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
        };
        function request(message) { return { type: messageConstants.SEND_MESSAGE_REQUEST, message }; }
        function success(message) { return { type: messageConstants.SEND_MESSAGE_SUCCESS, message }; }
        function failure(error) { return { type: messageConstants.SEND_MESSAGE_FAILURE, error }; }
    
    } catch (error) {
        console.log("Error at messageSend", error);
    }
}

export const messageActions = {
    messageSend
}